import gsap, { Power2 } from 'gsap'
import { SplitText } from 'gsap/SplitText'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)



// new SplitText(".js-split-text", {type:"words,lines", linesClass:"animate-line", position:"absolute"})
// // new SplitText("h1", {type:"words,lines", linesClass:"animate-line", position:"absolute"})
// // new SplitText("h2", {type:"words,lines", linesClass:"animate-line", position:"absolute"})


// //let splittedArr = [...$('.js-split-text'), $('h1'), $('h2')]

// let splittedArr = [...$('.js-split-text')]

// $.each(splittedArr, function(){
//         ScrollTrigger.create({
//       trigger: this,
//       start: "top bottom-=30px", // el top, screen bottom
//       once: true,
//       onEnter: () => {
//         gsap.to($(this).find('.animate-line div'), { y: 0, delay: 0.2, duration: 0.75, ease: Power2.easeIn })
//       }
//     });
// })




let machineWriteTextsArr = [...$('.js-machine-write-text')];
$.each(machineWriteTextsArr, function() {
    const mySplitText = new SplitText(this, { type: "words,chars" }); // Split by words and chars
    gsap.set(mySplitText.chars, { opacity: 0, x: 20 });

    ScrollTrigger.create({
        trigger: this,
        start: "top bottom-=30px",
        once: true,
        onEnter: () => {
            gsap.to(mySplitText.chars, {
                opacity: 1,
                x: 0,
                duration: 0.05,
                stagger: 0.05,
                ease: "power1.out",
                onStart: () => {
                    this.style.opacity = 1;
                },
            });
        }
    });
});


//  const target = document.querySelector(".js-machine-write-text");

// // Create SplitText instance
// const mySplitText = new SplitText(target, { type: "chars" });

// // Set initial state of characters
// gsap.set(mySplitText.chars, { opacity: 0, x: 20 });

// // Create Intersection Observer to detect when element is in view
// const observer = new IntersectionObserver(
//   (entries) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         // Animate characters when element is in view
//         gsap.to(mySplitText.chars, {
//           opacity: 1,
//           x: 0,
//           duration: 0.05,
//           stagger: 0.05,
//           ease: "power1.out",
//           onStart: () => {
//             target.style.opacity = 1; // Make container visible
//           },
//         });
//         // Stop observing after animation triggers
//         observer.unobserve(target);
//       }
//     });
//   },
//   {
//     threshold: 0.5, // Trigger when 50% of the element is visible
//   }
// );

// // Start observing the target element
// observer.observe(target);